import * as React from "react";

import { RobotoButton } from "@/shared/components";
import { TuneIcon } from "@/shared/foundation/icons/mui";

import { OrgLimitsDialog } from "./OrgLimitsDialog";

interface OrgLimitsButtonProps {
  orgId: string;
}

/**
 * Opens the system-user-only org limits viewer/editor. Render inside a
 * ``SystemUserOnly`` gate — the button itself does no gating.
 *
 * The dialog is mounted only while open, so closing it discards all edit
 * state and no limits are fetched during normal page browsing.
 */
export const OrgLimitsButton: React.FC<OrgLimitsButtonProps> = ({ orgId }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <RobotoButton
        eventName={"OrgLimitsClicked"}
        eventProperties={{ orgId }}
        onClick={() => setOpen(true)}
        startIcon={<TuneIcon fontSize="small" />}
        variant="outlined"
      >
        Limits
      </RobotoButton>
      {open && (
        <OrgLimitsDialog orgId={orgId} open onClose={() => setOpen(false)} />
      )}
    </>
  );
};
